import React, { useState } from "react";
import textureImage from "../../assets/images/12188655_4914784.jpg";
import {
  FaSprayCan, FaPaintRoller, FaTools, FaFlask, FaWater, FaShieldAlt,
  FaIndustry, FaCogs, FaBrush, FaAtom, FaTint, FaPumpSoap,
  FaLayerGroup, FaRulerCombined, FaWrench
} from "react-icons/fa";

export const Form = () => {
  const [formData, setFormData] = useState({
    name: "", company: "", email: "", phone: "", message: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you for contacting us!");
    setFormData({
      name: "", company: "", email: "", phone: "", message: ""
    });
  };

  return (
    <div className="min-h-screen bg-[#F1F0EA] pt-0 pb-10 px-4 flex flex-col items-center relative overflow-hidden">

      {/* Hero Section */}
      <div
        className="w-full mt-[80px] py-40 flex justify-center items-center text-center relative z-10 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(83, 80, 80, 0.5), rgba(2, 2, 2, 0.34)), url(${textureImage})`,
        }}
      >
        <h1 className="text-5xl md:text-6xl font-bold text-white drop-shadow-lg">
          Get in Touch
        </h1>
      </div>

      {/* Floating Icons */}
      <div className="absolute inset-0 pointer-events-none z-0">
        {[FaSprayCan, FaPaintRoller, FaTools, FaFlask, FaWater, FaShieldAlt,
          FaIndustry, FaCogs, FaBrush, FaAtom, FaTint, FaPumpSoap,
          FaLayerGroup, FaRulerCombined, FaWrench].map((Icon, index) => {
            const positions = [
              "top-10 left-10", "top-20 right-16", "bottom-20 left-20", "top-1/2 left-[45%]",
              "bottom-10 right-10", "top-1/3 left-5", "bottom-1/3 right-6", "top-16 right-[30%]",
              "bottom-32 left-[35%]", "top-[70%] left-[60%]", "top-[15%] right-[5%]",
              "top-[55%] right-[45%]", "bottom-[15%] right-[30%]", "bottom-[10%] left-[10%]",
              "top-[10%] left-[50%]"
            ];
            const sizes = ["text-5xl", "text-5xl", "text-5xl", "text-4xl", "text-5xl", "text-5xl", "text-6xl",
              "text-5xl", "text-4xl", "text-5xl", "text-4xl", "text-4xl", "text-4xl", "text-5xl", "text-4xl"];
            return (
              <Icon
                key={index}
                className={`text-[#e4dede] ${sizes[index]} animate-float-slow absolute ${positions[index]}`}
              />
            );
        })}
      </div>

      {/* Section Heading */}
      <div className="max-w-3xl w-full text-center mt-12 mb-8 relative z-10">
        <h2 className="text-4xl font-bold text-[#ad2624] mb-4">Contact Us</h2>
        <p className="text-gray-700 text-lg">
          We'd love to hear from you. Please fill out the form below and we'll get back to you shortly.
        </p>
      </div>

      {/* Contact Form */}
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-2xl bg-white p-8 rounded-2xl shadow-lg space-y-6 relative z-10"
      >
        <div className="flex flex-col md:flex-row gap-6">
          <div className="flex-1">
            <label htmlFor="name" className="block mb-1 font-medium">
              Your Name <span className="text-red-500">*</span>
            </label>
            <input
              id="name"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg p-4 focus:outline-none focus:ring-2 focus:ring-[#ad2624]"
            />
          </div>
          <div className="flex-1">
            <label htmlFor="company" className="block mb-1 font-medium">
              Your Company <span className="text-red-500">*</span>
            </label>
            <input
              id="company"
              type="text"
              name="company"
              value={formData.company}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg p-4 focus:outline-none focus:ring-2 focus:ring-[#ad2624]"
            />
          </div>
        </div>

        <div>
          <label htmlFor="email" className="block mb-1 font-medium">
            Your Email <span className="text-red-500">*</span>
          </label>
          <input
            id="email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full border border-gray-300 rounded-lg p-4 focus:outline-none focus:ring-2 focus:ring-[#ad2624]"
          />
        </div>

        <div>
          <label htmlFor="phone" className="block mb-1 font-medium">
            Your Phone Number <span className="text-red-500">*</span>
          </label>
          <input
            id="phone"
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
            className="w-full border border-gray-300 rounded-lg p-4 focus:outline-none focus:ring-2 focus:ring-[#ad2624]"
          />
        </div>

        <div>
          <label htmlFor="message" className="block mb-1 font-medium">
            Your Message <span className="text-red-500">*</span>
          </label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows="5"
            required
            className="w-full border border-gray-300 rounded-lg p-4 focus:outline-none focus:ring-2 focus:ring-[#ad2624]"
          ></textarea>
        </div>

        <button
          type="submit"
          className="w-full bg-[#ad2624] text-white text-lg font-semibold py-3 rounded-lg hover:bg-[#922021] transition-all"
        >
          Send Message
        </button>
      </form>

      {/* Floating Animation Keyframes */}
      <style>
        {`
          @keyframes floatSlow {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
          }

          .animate-float-slow {
            animation: floatSlow 6s ease-in-out infinite;
          }
        `}
      </style>
    </div>
  );
};

export default Form;
